import { defineStore } from 'pinia'
import { api } from '@/plugins/axios';

export const useProductStore = defineStore('product-store', {
  // State (if you need to store any date-related state)
  state: () => ({
    loading: false,
    categories: [],
    attributes: [],
    products: [],
    pagination: {
      sortBy: "id",
      descending: true,
      page: 1,
      rowsPerPage: 5,
      rowsNumber: 0,
    },
    filters: {
      category_id: [],
      attributes: {},
      search: "",
    }
  }),

  // Getters (computed properties)
  getters: {},

  // Actions (methods)
  actions: {
    async fetchProducts() {
      this.loading = true
      const { page, rowsPerPage, sortBy, descending } = this.pagination
      const { category_id, search } = this.filters

      let url = `get-products?page=${page}&limit=${rowsPerPage}`

      if (sortBy) {
        url += `&orderBy=${sortBy}&orderType=${descending ? "DESC" : "ASC"}`
      }

      let filterArray = []
      if (category_id.length > 0) {
        filterArray.push({
          column: "category_id",
          value: category_id.join(","),
          condition: "in"
        })
      }
      
      const attributeIds = Object.keys(this.filters.attributes)
      const optionIds = Object.values(this.filters.attributes).flat()

      if (attributeIds.length > 0) {
        filterArray.push({
          column: "attribute_id",
          condition: "in",
          value: attributeIds.join(",")
        })
      }

      if (optionIds.length > 0) {
        filterArray.push({
          column: "attribute_option_id",
          condition: "in",
          value: optionIds.join(",")
        })
      }

      if (search) {
        filterArray.push({
          column: "name",
          value: search,
          condition: "like"
        })
      }

      if (filterArray.length > 0) {
        url += `&filterArray=${JSON.stringify(filterArray)}`
      }

      try {
        const response = await api.get(url)        
        this.products = response.data.results.data
        this.pagination.rowsNumber = response.data.results.pagination.total // total count        
      } catch (error) {
        console.error('Error fetching products:', error)
      } finally {
        this.loading = false
      }
    },

    setPage(page) {
      this.pagination.page = page
      this.fetchProducts()
    },

    setSort(sortBy, descending) {      
      this.pagination.sortBy = sortBy
      this.pagination.descending = descending
      this.fetchProducts()
    },

    setSearch(search) {
      this.filters.search = search
      this.fetchProducts()
    },

    setFilterCategory(category) {
      const index = this.filters.category_id.indexOf(category)
      if (index > -1) {
        this.filters.category_id.splice(index, 1)
      } else {
        this.filters.category_id.push(category)
      }
      this.pagination.page = 1
      this.fetchProducts()
    },

    setFilterAttribute(attributeId, optionId) {
      if (!this.filters.attributes[attributeId]) {
        this.filters.attributes[attributeId] = []
      }

      const optionIndex = this.filters.attributes[attributeId].indexOf(optionId)

      if (optionIndex > -1) {
        // remove option if already selected
        this.filters.attributes[attributeId].splice(optionIndex, 1)

        // if no options left for this attribute, remove the attribute
        if (this.filters.attributes[attributeId].length === 0) {
          delete this.filters.attributes[attributeId]
        }
      } else {
        // add new option
        this.filters.attributes[attributeId].push(optionId)
      }

      this.pagination.page = 1
      this.fetchProducts()
    },
    resetFilters() {
      this.filters = {
        category_id: [],
        attributes: {},
        search: "",
      }
      this.pagination.page = 1
      this.fetchProducts()
    }

  }
});
